import 'core-js/stable'
import Vue from 'vue'
import CoreuiVuePro from '@coreui/vue-pro'

import App from './App'
import router from './router/index'
import store from './store/index'
import i18n from './plugins/i18n_single_language_file'
import VueConfirmDialog from 'vue-confirm-dialog'
import { freeSet as icons } from '@coreui/icons'      // import { iconsSet as icons} from './assets/icons/icons.js'
import VueQuillEditor from 'vue-quill-editor'         // Text Editors

import { mapState } from "vuex";
import { axiosInstance } from './helper/axios.js'
import { globalFunc, globalVar } from './helper/global.js' // Global Functions/Variables
import backend from "./router/backend.js"; // Api Routing Table
import "./filters/global.js"; // Global filters
import { initializeEcho } from "./helper/echo.js"; // Laravel Echo for WebSocket
import { initializeSupplierDocumentRealtime } from "./helper/supplierDocumentRealtime.js";
import { notifyAndReloadIfUpdated } from "./helper/appUpdateNotifier.js";
import {
  installGlobalZoomPrevention,
  installMobileOverlayScrollLock,
} from "./helper/mobileInteractions.js";

// MC Global Components
import AlertSection from './components/AlertSection'
import Spinner from './components/Spinner'
import ProductEditModal from "./components/ProductEditModal.vue";
import ProductQuickEdit from "./views/products/asides/ProductQuickEdit.vue";
import ViewProductModal from "./components/ProductView/Modal.vue";
import ShoppingCartSidebar from "./views/restaurant-views/supplier-orders/new-order/ShoppingCartSidebar.vue";

import VueImg from "v-img";
import PrettyCheck from "pretty-checkbox-vue/check";
import PortalVue from "portal-vue";

//#region Vue Toastification v1 (Vue 3)
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css"; // Import the CSS or use your own!
const toast_options = {
  // position: POSITION.TOP_CENTER,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};
//#endregion

//#region Vuelidate Error Extractor 2
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  // Define common validation messages.
  messages: {
    required: "{attribute} is required!",
    email: "{attribute} is not a valid Email address!",
    minLength:
      "{attribute} is a required field and must be at least {min} characters.",
    minDate: "{attribute} must not be less than Today or From Date!",
  },
});
//#endregion

// Floating Vue
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

//#region Mixin
// mixin içerisindeki tüm option'lar (data, method, computed prop…) component'in kendi option'ları içerisinde 'mixed' olarak yer alır.
Vue.mixin({
  computed: {
    ...mapState({
      auth_user: (state) => state.auth.userData,
      auth_user_roles: (state) => {
        const roles = state.auth.userData?.roles;
        if (!roles || !Array.isArray(roles) || roles.length === 0) {
          return [];
        }
        // roles can be array of objects {name: "..."} or array of strings
        return roles.map((role) =>
          typeof role === "string" ? role : role.name
        );
      },
      selectedFirm: (state) => state.selectedFirm,
      isRestaurant: (state) =>
        state.selectedFirm && state.selectedFirm.type == "R",
      isManufacturer: (state) =>
        state.selectedFirm && state.selectedFirm.type == "M",
      isSupplier: (state) =>
        state.selectedFirm && state.selectedFirm.type == "S",
      isSuperAdmin: (state) =>
        state.auth.userData &&
        state.auth.userData.roles.includes("Super Admin"),
    }),
    // Check if user is ONLY an Order Admin (not Super Admin or Firm Admin)
    isOrderAdminOnly() {
      const roles = this.auth_user_roles || [];
      const hasOrderAdmin = roles.includes("Order Admin");
      const hasSuperAdmin = roles.includes("Super Admin");
      const hasFirmAdmin = roles.includes("Firm Admin");
      return hasOrderAdmin && !hasSuperAdmin && !hasFirmAdmin;
    },
  },
});
//#endregion

//#region Vue Select
// Custom Components
import vSelect from "vue-select";
// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) => createElement("span", "❌"),
  },
  // OpenIndicator: {
  //   render: createElement => createElement('span', '🔽'),
  // },
});
//#endregion

//#region idle-vue
// idle-vue is a Vue.js plug-in, that detects when the user hasn't interacted with your app for a while.
// https://www.npmjs.com/package/idle-vue
import IdleVue from "idle-vue";
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 30 * 60 * 1000, // 30 minutes
  startAtIdle: false,
});
//#endregion

Vue.use(CoreuiVuePro);
Vue.use(VueConfirmDialog);
Vue.use(VueQuillEditor);
Vue.use(VueImg);
Vue.use(PortalVue);
Vue.use(Toast, toast_options);
Vue.use(FloatingVue);

// Components
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.component("alert-section", AlertSection);
Vue.component("mc-spinner", Spinner);
Vue.component("product-edit-modal", ProductEditModal);
Vue.component("product-quick-edit", ProductQuickEdit);
Vue.component("view-product-modal", ViewProductModal);
Vue.component("shopping-cart-sidebar", ShoppingCartSidebar);
Vue.component('p-check', PrettyCheck);
Vue.component('formSummary', templates.multiErrorExtractor.foundation6)

// Prototypes
Vue.prototype.$log = console.log.bind(console);
Vue.prototype.$backend = backend;
Vue.prototype.$axios = axiosInstance;
Vue.prototype.$globalFunc = globalFunc;
Vue.prototype.$globalVar = globalVar;

async function initializeApp() {
  if (notifyAndReloadIfUpdated()) {
    return;
  }

  // On every page load, validate the token from the persisted state
  // This will pause app initialization until the user's session is validated.
  await store.dispatch("auth/validateToken");

  // Uygulama acilir acilmaz tum sayfalarda zoom engelini devreye al.
  installGlobalZoomPrevention();

  // Mobil overlay'lerde touch scroll'un body'ye sizmasini engelle.
  installMobileOverlayScrollLock();

  // Initialize Laravel Echo after authentication
  initializeEcho();

  const app = new Vue({
    el: "#app",
    router,
    store,
    icons,
    i18n,
    template: "<App/>",
    components: {
      App,
    },

    // methods: {
    //   // Sayfanın yenilenmesi (F5) durumunda:
    //   ...mapActions("auth", ["getAuthData"]),
    // },
    created() {
      // Javascript Array except (keys)
      Array.prototype.except = function (keys) {
        return this.filter((x, index) => {
          return typeof keys === "number"
            ? index !== keys
            : keys.indexOf(index) === -1;
        });
      };

      Array.prototype.sortArray = function (key) {
        // Set slice() to avoid to generate an infinite loop!
        return this.slice().sort(function (a, b) {
          return a[key] - b[key];
        });
      };
    },
    mounted() {
      // Sayfanın yenilenmesi (F5) durumunda:
      // this.getAuthData(); // App.vue created() içinde zaten çağrılıyor.

      if (!this.selectedFirm && this.$route.path !== "/") {
        router.push({ name: "Dashboard" });
      }
    },
  });

  initializeSupplierDocumentRealtime(app);
}

initializeApp();
